import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

let Bar

const ProductAnalyticsChart = ({
  data, labels, heading, title, leftAxisTitle, leftAxisOffsetLeft, color, percentage,
}) => {
  const [isLoaded, setIsLoaded] = useState()

  useEffect(() => {
    import('react-chartjs-2').then(module => {
      Bar = module.Bar
      setIsLoaded(true)
    })
  }, [])

  if (!isLoaded) return null

  Chart.defaults.global.defaultFontFamily = '"Source Sans Pro", Helvetica, sans-serif'
  Chart.defaults.global.defaultFontColor = '#6D6D6D'
  Chart.defaults.global.defaultFontSize = 13
  const chartConfiguration = {
    data: {
      datasets: [
        {
          label: '',
          data,
          backgroundColor: color,
        },
      ],
      labels,
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: {
          top: 20,
        },
      },
      scales: {
        xAxes: [{
          barPercentage: 0.7,
          gridLines: {
            color: '#eee',
          },
          ticks: {
            beginAtZero: true,
          },
        }],
        yAxes: [{
          gridLines: {
            color: '#eeeeee',
            drawTicks: false,
            zeroLineColor: '#eee',
          },
          ticks: {
            display: false,
          },
        }, {
          position: 'right',
          gridLines: {
            display: false,
          },
          ticks: {
            display: false,
          },
        }],
      },
      legend: {
        position: 'bottom',
        onClick: (e) => e.stopPropagation(),
        labels: {
          boxWidth: 0,
        },
      },
      tooltips: {
        enabled: false,
      },
      hover: {
        animationDuration: 0,
      },
      animation: {
        duration: 0,
        onComplete() {
          const chartInstance = this.chart
          const ctx = chartInstance.ctx
          ctx.textAlign = 'center'
          ctx.textBaseline = 'bottom'
          ctx.fillStyle = color

          this.data.datasets.forEach((dataset, i) => {
            const meta = chartInstance.controller.getDatasetMeta(i);
            meta.data.forEach((bar, index) => {
              ctx.fillText(dataset.data[index] + (percentage ? '%' : ''), bar._model.x, bar._model.y - 5);
            })
          })
        },
      },
    },
  }

  return (
    <div className="chart-container">
      {heading
        && (
        <div className="chart-container__heading">
          <h3 dangerouslySetInnerHTML={{ __html: heading }} />
        </div>
        )
      }
      <div className="chart-container__description">
        <p dangerouslySetInnerHTML={{ __html: title }} />
      </div>

      <div className="chart-container__chart">
        <div className="chart-container__left-axis" style={{ left: `${leftAxisOffsetLeft}px` }}>{leftAxisTitle}</div>
        <Bar redraw data={chartConfiguration.data} options={chartConfiguration.options} />
      </div>
    </div>
  )
}

ProductAnalyticsChart.propTypes = {
  data: PropTypes.array,
  labels: PropTypes.array,
  heading: PropTypes.string,
  leftAxisTitle: PropTypes.string,
  leftAxisOffsetLeft: PropTypes.number,
  color: PropTypes.string.isRequired,
}

ProductAnalyticsChart.defaultPropTypes = {
  data: [],
  labels: [],
  heading: null,
  leftAxisTitle: null,
  leftAxisOffsetLeft: 15,
}

export default ProductAnalyticsChart
